import { REST } from './utils';

const { GET, POST } = REST('/colleagueInvitation');

type Invitation = {
    accepted: boolean;
    firstName: string;
    lastName: string;
    email: string;
    message: string;
    dateSent: string;
};

interface InvitationPayload {
    invitations: Invitation[];
    invitationsLeftNumber: number;
    invitationsTotalNumber: number;
}

export const getInvitations = (articleId: string): Promise<InvitationPayload> =>
    GET('/getData', undefined, { urlParams: { articleId } });

export const invite = (articleId: string, invitation: Omit<Invitation, 'dateSent'>): Promise<InvitationPayload> =>
    POST('/invite', invitation, { urlParams: { articleId } });
